import Breadcrumbs from "components/Shared/Breadcrumb/Breadcrumbs"
import Navbar from "components/Shared/Navigation/Navbar"
import SidebarMenu from "components/Shared/SidebarMenu/SidebarMenu"
import { parseJwt } from "utils/helpers"
import { useAppSelector } from "hooks/hooksStore"
import useCommon from "hooks/useCommon"
import { useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { RootState } from "store/store"
import { getAccessToken } from "utils/token"

function PrivateOutlet() {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { setAuthUser } = useCommon()
  const { authUser } = useAppSelector((state: RootState) => state.common)
  const isLocalAuthBypass = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
  const token = getAccessToken()

  useEffect(() => {
    if (!token) {
      if (!isLocalAuthBypass) {
        if (!sessionStorage.getItem("redirectUrl")) {
          sessionStorage.setItem("redirectUrl", pathname + search)
        }
        navigate("/")
      }
      return
    }

    if (!authUser) setAuthUser(parseJwt(token))
    switch (pathname?.toLowerCase()) {
      case "/market-prices":
        navigate("/market-prices/dashboard")
        break
      case "/mfi":
        navigate("/mfi/surveys")
        break
      case "/rpme":
        navigate("/rpme/surveys")
        break
      case "/gorp":
        navigate("/gorp/gorpReports")
        break
      case "/admin":
        navigate("/admin/AdminUnitsL1")
        break
      case "/household":
        navigate("/household/surveys")
        break
      default:
        break
    }
  }, [authUser, isLocalAuthBypass, navigate, pathname, search, setAuthUser, token])

  if (!token && !isLocalAuthBypass) return null

  return (
    <>
      <Navbar />
      <div className="d-flex">
        <SidebarMenu />
        <div className="container rightContent">
          <Breadcrumbs />
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default PrivateOutlet
